import React from 'react'
import { Link } from 'react-router-dom'

const SugarDassySubscriptionsTabsModal = () => {
  return (
    <div className='modal-tabs-follow-sec'>
        <div className='search-section-following'>
        <div className='search-box'>
          <div className="search-container">
            <form action="">
              <div className='form-search-box'>
                <button type="submit">
                  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3418 19.25C16.1512 19.25 20.0501 15.3512 20.0501 10.5417C20.0501 5.7322 16.1512 1.83334 11.3418 1.83334C6.53228 1.83334 2.63342 5.7322 2.63342 10.5417C2.63342 15.3512 6.53228 19.25 11.3418 19.25Z" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.9668 20.1667L19.1334 18.3333" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
                <input type="search" placeholder="Search.." name="" />
              </div>
            </form>
          </div>
        </div>
    </div>
    <div className='alert-box-com'>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border '>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
        <div className='alert-box'>
            <div class="alert alert-dismissible d-flex align-items-center fade show mb-3" role="alert">
                <div className='left-alert-box d-flex align-items-center'>
                    <div className='left-img-box'>
                        <div className='img-box'></div>
                    </div>
                    <div className='right-text-box'>
                        <h6>iamchloe</h6>
                        <p>Chloe</p>
                    </div>
                </div>
                <div className='right-alert-box d-flex align-items-center monthly-alert'>
                    <div className='btn-box-alert'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>$8.99 monthly</Link>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default SugarDassySubscriptionsTabsModal
